import {Component, OnInit, ChangeDetectionStrategy, Input} from '@angular/core';
import {Trip, Vehicle} from '../../../../@core/interfaces/common';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

const bikeIds = {
  'DIGINU ROADSTER 111': 1,
  'SA DIGINU TRIAL UNIT 2': 2,
  'PN 8719': 3,
  'ML 4827': 4,
  'VB 4285': 5,
};

@Component({
  selector: 'vehicle-marker-popup',
  templateUrl: './vehicle-marker-popup.component.html',
  styleUrls: ['./vehicle-marker-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VehicleMarkerPopupComponent implements OnInit {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService
  ) {}
  @Input() vehicle: Vehicle;

  get engineAlert(): boolean {
    return !this.vehicle.indicators.engine;
  }

  get batteryAlert(): boolean {
    return !this.vehicle.indicators.battery;
  }

  get fuelProblem(): boolean {
    return this.vehicle.indicators.gas < 80;
  }

  SetVehicleStatus(status){
    
  //   if(this.vehicle.name=='DIGINU ROADSTER 111')
  //   {
  //     var bike_id=1;
  // }
  // if(this.vehicle.name=='CR 1565')
  //   {
  //     var bike_id=2;
  // }
  var bike_id = bikeIds[this.vehicle.name];
  this.UpdateData('https://nsevbackend.mysmartpo.com/api/set_power', { 'status': status, 'bike_id': bike_id }).subscribe(
    (response) => {
      console.log(response);
      this.toastr.success('Powered On', 'Success');
    }, 
    (error) => {
      console.error('Error fetching data', error);
      this.toastr.error('Powered Off', 'Error');
    }
  );
}
  UpdateData(apiUrl,data): Observable<any> {
    return this.http.post<any>(apiUrl, data);

  }

  ngOnInit() {
  }

}
